import React, {
  useEffect,
  useRef,
  useState,
} from 'react';
import {
  TableRow,
  FormControlLabel,
  Radio,
  Checkbox,
  Collapse,
  Table,
} from '@mui/material';
import Box from '@mui/material/Box';
import TableCell from '@mui/material/TableCell';
import { useDrag, useDrop } from 'react-dnd';
import { MoreOptions } from '../../Table/assets/MoreOptions';
import TableHead from '@mui/material/TableHead';
import TableBody from '@mui/material/TableBody';
import ServiceRow from './ServiceRow';
import { debounce } from 'lodash';
import { servicePackage } from '../../../schema/servicePackage';
import api from '../../../services/api';
import {hasPermissionByPriority} from "../../../core/permissions/hasPermission";
import {ROLE_PRIORITIES} from "../../../core/permissions/permissions";
import {useStateContext} from "../../../hooks/useStateContext";
import {DoneRounded} from "@mui/icons-material";
import CloseRoundedIcon from "@mui/icons-material/CloseRounded";

const ItemTypes = {
  BOX: 'ROW',
};

const ServiceGroupRow = ({
  row,
  index,
  moveRow,
  clickOnDelete,
  clickOnDeleteService,
  handleSetExtraService,
  calculatorMode,
  clickOnEdit,
  clickOnOpenViewPrices,
}) => {
  const [open, setOpen] = useState(true);

  const [rows, setRows] = useState(row.services);

  const debouncedOnChange = debounce(handleDebouncedOnChange, 200);

  const moveServiceRow = (fromIndex, toIndex) => {
    debouncedOnChange(fromIndex, toIndex);
  };

  useEffect(() => {
    setRows(row.services);
  }, [row]);

  function handleDebouncedOnChange(fromIndex, toIndex) {
    const updatedRows = [...rows];
    const [movedRow] = updatedRows.splice(fromIndex, 1);
    updatedRows.splice(toIndex, 0, movedRow);
    setRows(updatedRows);

    updatedRows.map((item, index) => {
      api.post(`/service-package-service/${item?.pivot?.id}`, {
        position: index,
      });
    });
  }

  const ref = useRef(null);

  const [{ isDragging }, drag] = useDrag({
    item: { type: ItemTypes.BOX },
    collect: (monitor) => ({
      isDragging: monitor.isDragging(),
    }),
  });

  const [, drop] = useDrop({
    accept: 'ROW',
    hover: (draggedItem) => {
      if (draggedItem.index !== index) {
        moveRow(draggedItem.index, index);
        draggedItem.index = index;
      }
    },
  });

  drag(drop(ref));

  const {user} = useStateContext();
  const isAdmin = hasPermissionByPriority(user.roles, ROLE_PRIORITIES[1]);

  return (
    <>
      <TableRow key={index} style={{ opacity: isDragging ? 0.5 : 1 }}>
        {/* <TableCell>
          <IconButton
            ref={ref}
            aria-label="drag-handle"
            sx={{ cursor: 'move' }}
          >
            <DragIndicatorRounded />
          </IconButton>
        </TableCell>*/}
        <TableCell>
          <MoreOptions
            disabledEdit={!isAdmin}
            disabledDelete={!isAdmin}
            clickOnEdit={() => {
              clickOnEdit({
                schema: servicePackage(),
                row: row,
                tab: 'service_packages',
              });
            }}
            clickOnDelete={() => {
              clickOnDelete();
            }}
          />
        </TableCell>
        <TableCell
          ref={ref}
          sx={{
            cursor: 'move',
            padding: '5px',
            '&:hover': {
              background: '#f3f3f3',
            },
          }}
        >
          {row?.name}
        </TableCell>
        <TableCell>
          <FormControlLabel
            value={row?.id}
            control={<Radio />}
            label={''}
            sx={{
              margin: '0px',
            }}
            disabled={row?.base}
          />
        </TableCell>
        <TableCell>
          <Checkbox
            disabled={row?.base}
            aria-label={`checkbox-${row?.id}`}
            checked={row?.extra}
            onChange={(event, checked) => {
              if (!calculatorMode) {
                handleSetExtraService(checked);
              }
            }}
          />
        </TableCell>
        <TableCell>
          {/*<Checkbox
            disabled={true}
            aria-label={`checkbox-assigned-${row?.id}`}
            checked={row?.assigned_staff}
            onChange={(event, checked) => {

            }}
          />*/}
          {row?.assigned_staff ? (
            <DoneRounded color={'success'} />
          ) : (
            <CloseRoundedIcon color={'disabled'} />
          )}
        </TableCell>
        <TableCell style={{ paddingBottom: 0, paddingTop: 0 }} colSpan={10}>
          <Collapse in={open} timeout="auto" unmountOnExit>
            <Box margin={1}>
              <Table size="small" aria-label="sub-items">
                <TableHead
                  sx={{
                    '& .MuiTableRow-root .MuiTableCell-root.MuiTableCell-head': {
                      border: 'none',
                      fontSize: '14px',
                      p: '10px',
                      color: '#fff',
                    },
                    background: 'rgb(37 104 97 / 82%)',
                  }}
                >
                  <TableRow>
                    <TableCell>Service Provider</TableCell>
                    <TableCell>Services</TableCell>
                    <TableCell>Staff Required</TableCell>
                    <TableCell>Includes</TableCell>
                    <TableCell
                      sx={{
                        textAlign: 'right',
                      }}
                    >
                      Cost Net
                    </TableCell>
                    <TableCell
                      sx={{
                        textAlign: 'right',
                      }}
                    >
                      VAT
                    </TableCell>
                    <TableCell
                      sx={{
                        textAlign: 'right',
                      }}
                    >
                      Cost Gross
                    </TableCell>
                    <TableCell>Currency</TableCell>
                    <TableCell>Type</TableCell>
                    <TableCell></TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {rows.map((subRow, index) => {
                    return (
                      <ServiceRow
                        key={index}
                        row={subRow}
                        index={index}
                        moveRow={moveServiceRow}
                        clickOnEdit={(value) => {
                          clickOnEdit(value);
                        }}
                        clickOnOpenViewPrices={() => {
                          clickOnOpenViewPrices(subRow);
                        }}
                        clickOnDelete={() => {
                          clickOnDeleteService(subRow?.pivot);
                        }}
                      />
                    );
                  })}
                </TableBody>
              </Table>
            </Box>
          </Collapse>
        </TableCell>
      </TableRow>
    </>
  );
};
export default ServiceGroupRow;
